module.exports = __webpack_public_path__ + "static/media/Deli_Wrong.10a0631e.svg";